import React, { useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "../../langs/useTranslation";
import { Typography, Paper, Grid, Switch } from "@material-ui/core";
import useStyles from "../../styles/deviceControlStyle";
import TextNoty from "../../helpers/textNoty";
import Slider from "@material-ui/core/Slider";
import { currentDateInUTC } from "../../helpers/datetimeHandlers";
import LoadingIndicator from "../commons/LoadingIndicator";
import {
  blockWindowsNotifyApi,
  usbLockApi,
  lockCombinationKeyApi,
  volumeApi,
  brightnessApi
} from "../../apis/deviceControlApi";
import { callVncAPI } from "../../helpers/vncLinkHandler";
import modalConfirm from "../Modal/modalConfirm";

const DeviceControlSet = props => {
  const [oldSlider, setOldSlider] = useState(0);
  const [action, setAction] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [IsVNCLoading, setIsVNCLoading] = useState(false);
  const actionRef = useRef("");
  const classes = useStyles();
  const {
    selectType,
    type,
    selectDevices,
    selectDevice,
    notAllowGroup,
    checked,
    setChecked,
    imgSrc,
    slider,
    setSlider,
    groupId,
    tagId,
    selectCompany,
    notAllowAndroid,
    disabled,
    numType,
    setVNCLink,
    setVNCExpiredDate,
    setDialogContent,
    handleVNCFailedDialogOpen,
    setOpen,
    checkAll,
    onClick
  } = props;
  const { t } = useTranslation("deviceControl");

  const sliderHandler = (event, newValue) => {
    setSlider(newValue);
  };

  const selectDisabled = useMemo(() => {
    if (type === "settingAlarm" || type === "settingSchedule") {
      if (selectType !== "group") {
        return true;
      }
      return false;
    }
    if (disabled) return true;
    if (numType === "single") {
      let androidValid;
      if (notAllowAndroid) {
        if (selectDevice) {
          androidValid = selectDevice.os_type === "android";
        }
      }
      return androidValid || !selectDevice;
    } else {
      let androidValid;
      if (notAllowAndroid) {
        if (selectDevices.length > 0) {
          androidValid = !!selectDevices.find(a => a.os_type === "android");
        }
      }
      return (
        androidValid ||
        selectDevices.length === 0 ||
        (notAllowGroup && selectDevices.length > 1)
      );
    }
  }, [
    selectDevices,
    selectDevice,
    type,
    disabled,
    numType,
    notAllowAndroid,
    notAllowGroup
  ]);

  const clickHandler = async e => {
    if (selectDisabled) return;
    if (onClick?.(e, type) === false) {
      return;
    }
    setOpen?.(false);
    // 單機
    if (numType === "single") {
      // android不行
      let androidValid;
      if (notAllowAndroid) {
        if (selectDevice) {
          androidValid = selectDevice.os_type === "android";
        }
      }
      if (androidValid) {
        TextNoty(t("noty.noSupportAndroid"));
        return;
      }
      // 沒選
      if (!selectDevice) {
        TextNoty(t("noty.noSelectDevice"));
        return;
      }
    }
    // 多機
    else {
      // android不行
      let androidValid;
      if (notAllowAndroid) {
        if (selectDevices.length > 0) {
          androidValid = !!selectDevices.find(a => a.os_type === "android");
        }
      }
      if (androidValid) {
        TextNoty(t("noty.noSupportAndroid"));
        return;
      }
      // 沒選
      if (selectDevices.length === 0) {
        TextNoty(t("noty.noSelectDevice"));
        return;
      }
      // 不允許多機
      if (
        selectDevices.length > 1 &&
        (type === "remoteTerminal" || type === "remoteDesktop")
      ) {
        TextNoty(t("noty.forSingleDevice"));
        return;
      }
    }
    modalConfirm({
      title: t(`common.${type}`),
      content: t("dialog.content"),
      onConfirm,
      onCancel
    });
  };

  const blurHandler = () => {
    setAction("slider");
    modalConfirm({
      title: t(`common.${type}`),
      content: t("dialog.content"),
      onConfirm,
      onCancel
    });
  };

  const stopEvent = e => {
    e.stopPropagation();
  };

  const onCancel = () => {
    if (actionRef.current === "slider") {
      setSlider(oldSlider);
    }
    setAction("");
  };

  const onConfirm = async () => {
    const successText = "dialog.successText";
    const devices = checkAll
      ? undefined
      : numType === "single"
      ? selectDevice
        ? [selectDevice]
        : selectDevices
      : selectDevices;
    if (actionRef.current === "slider") {
      if (slider) {
        switch (type) {
          case "volumes":
            await volumeApi(
              selectType,
              selectCompany,
              devices,
              groupId,
              tagId,
              true,
              "volume",
              slider,
              t,
              successText
            ).then(res => {
              if (res) {
                setChecked(true);
                setOldSlider(slider);
              } else {
                setSlider(oldSlider);
              }
            });
            break;
          case "brightness":
            await brightnessApi(
              selectType,
              selectCompany,
              devices,
              groupId,
              tagId,
              true,
              "brightness",
              slider,
              t,
              successText
            ).then(res => {
              if (res) {
                setChecked(true);
                setOldSlider(slider);
              } else {
                setSlider(oldSlider);
              }
            });
            break;
          default:
            break;
        }
      } else if (slider === 0) {
        switch (type) {
          case "volumes":
            await volumeApi(
              selectType,
              selectCompany,
              devices,
              groupId,
              tagId,
              false,
              "volume",
              slider,
              t,
              successText
            ).then(res => {
              if (res) {
                setChecked(false);
                setOldSlider(slider);
              } else {
                setSlider(oldSlider);
              }
            });
            break;
          case "brightness":
            await brightnessApi(
              selectType,
              selectCompany,
              devices,
              groupId,
              tagId,
              false,
              "brightness",
              slider,
              t,
              successText
            ).then(res => {
              if (res) {
                setChecked(false);
                setOldSlider(slider);
              } else {
                setSlider(oldSlider);
              }
            });
            break;
          default:
            break;
        }
      }
      setAction("");
    } else {
      if (setSlider) {
        if (checked === false) {
          switch (type) {
            case "volumes":
              await volumeApi(
                selectType,
                selectCompany,
                devices,
                groupId,
                tagId,
                !checked,
                "volume",
                30,
                t,
                successText
              ).then(res => {
                if (res) {
                  setSlider(30);
                  setOldSlider(30);
                  setChecked(true);
                }
              });
              break;

            case "brightness":
              await brightnessApi(
                selectType,
                selectCompany,
                devices,
                groupId,
                tagId,
                !checked,
                "brightness",
                30,
                t,
                successText
              ).then(res => {
                if (res) {
                  setSlider(30);
                  setOldSlider(30);
                  setChecked(true);
                }
              });
              break;
            default:
              break;
          }
        } else {
          switch (type) {
            case "volumes":
              await volumeApi(
                selectType,
                selectCompany,
                devices,
                groupId,
                tagId,
                !checked,
                "volume",
                0,
                t,
                successText
              ).then(res => {
                if (res) {
                  setSlider(0);
                  setOldSlider(0);
                  setChecked(false);
                }
              });
              break;
            case "brightness":
              await brightnessApi(
                selectType,
                selectCompany,
                devices,
                groupId,
                tagId,
                !checked,
                "brightness",
                0, // slider
                t,
                successText
              ).then(res => {
                if (res) {
                  setSlider(0);
                  setOldSlider(0);
                  setChecked(false);
                }
              });
              break;

            default:
              break;
          }
        }
      } else {
        switch (type) {
          case "remoteDesktop":
            await callVncAPI(
              numType === "single" ? selectDevice.id : selectDevices[0]?.id,
              numType === "single" ? selectDevice : selectDevices[0],
              numType === "single"
                ? selectDevice.nubis_version
                : selectDevices[0]?.nubis_version,
              setIsLoading,
              setVNCLink,
              setVNCExpiredDate,
              setDialogContent,
              handleVNCFailedDialogOpen,
              t,
              "deviceControl"
            );
            break;
          case "lockUsbDrives":
            await usbLockApi(
              selectType,
              selectCompany,
              devices,
              groupId,
              tagId,
              !checked,
              "lock_usb",
              currentDateInUTC(),
              t,
              successText
            ).then(res => {
              if (res) {
                setChecked(!checked);
              }
            });
            break;
          case "lockFunctionKey":
            await lockCombinationKeyApi(
              selectType,
              selectCompany,
              devices,
              groupId,
              tagId,
              !checked,
              "disable_combination_key",
              currentDateInUTC(),
              t,
              successText
            ).then(res => {
              if (res) {
                setChecked(!checked);
              }
            });
            break;
          case "blockWindowsNotify":
            await blockWindowsNotifyApi(
              selectType,
              selectCompany,
              devices,
              groupId,
              tagId,
              !checked,
              "disable_windows_notify",
              currentDateInUTC(),
              t,
              successText
            ).then(res => {
              if (res) {
                setChecked(!checked);
              }
            });
            break;
          default:
            break;
        }
      }
      setAction("");
    }
  };

  useEffect(() => {
    actionRef.current = action;
  }, [action]);

  return (
    <Grid
      item
      xs={12}
      sm={12}
      md={6}
      lg={4}
      xl={4}
      className={classes.deviceControlSet}
    >
      <Paper
        elevation={0}
        onClick={clickHandler}
        className={`${classes.controlPaper} ${
          selectDisabled ? classes.notAllow : ""
        }`}
      >
        <div className={classes.controlTop}>
          <div className={classes.controlLeft}>
            {selectDisabled ? (
              <imgSrc.Gray className={classes.icon} />
            ) : (
              <imgSrc.Black className={classes.icon} />
            )}
            <div className={classes.controlTextSet}>
              <Typography variant="body1">{t(`common.${type}`)}</Typography>
              {notAllowGroup && (
                <Typography variant="body2" color="secondary">
                  {t("common.onlyForSingle")}
                </Typography>
              )}
              {notAllowAndroid && (
                <Typography variant="body2" color="secondary">
                  {t("common.onlyForWindows")}
                </Typography>
              )}
            </div>
          </div>
          {setChecked && (
            <Switch
              color="primary"
              disabled={selectDisabled}
              checked={checked}
              onChange={clickHandler}
              onClick={stopEvent}
            />
          )}
        </div>
        {slider === 0 || slider ? (
          <div className={classes.slider}>
            <Slider
              disabled={selectDisabled}
              value={slider}
              onChange={sliderHandler}
              onChangeCommitted={blurHandler}
              onClick={stopEvent}
            />
            <Typography
              variant="body2"
              color={selectDisabled ? "secondary" : "primary"}
              className={classes.sliderText}
            >
              {slider}
            </Typography>
          </div>
        ) : (
          ""
        )}
      </Paper>
      {isLoading ? (
        <div className={classes.wholePageLoading}>
          <Typography variant="h6" color="secondary">
            {t("tasks.connectingToDevice")}
          </Typography>
          <Typography variant="caption" color="secondary">
            {t("tasks.noticeThePopoutWindowBlocker")}
          </Typography>
          <Typography variant="caption" color="secondary">
            {t("tasks.waitVncConnectionTime")}
          </Typography>
          <LoadingIndicator />
        </div>
      ) : (
        ""
      )}
    </Grid>
  );
};

export default DeviceControlSet;
